import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"min-height":"150px"}
}
const _hoisted_2 = { class: "flex w-full justify-end mb-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Filter Tanggal", -1)
const _hoisted_4 = {
  key: 0,
  class: "flex w-full my-auto"
}
const _hoisted_5 = {
  key: 1,
  class: "w-full"
}
const _hoisted_6 = {
  key: 2,
  class: "flex justify-center w-full"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "font-semibold text-center mx-auto my-auto" }, "Tidak Ada Riwayat Penyesuaian", -1)
const _hoisted_8 = { class: "p-col-12 block" }
const _hoisted_9 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_CardComissionHistory = _resolveComponent("CardComissionHistory")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["btn-custom-outline flex cursor-pointer gap-2 px-2 py-1 items-center", $setup.isUsingFilter ? 'primary-color' : 'grey-color'],
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showDateFilter($event)))
      }, [
        _hoisted_3
      ], 2)
    ]),
    ($setup.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_ProgressSpinner, {
            strokeWidth: "2px",
            class: "m-auto"
          })
        ]))
      : _createCommentVNode("", true),
    ($setup.dataHistory.length > 0 && !$setup.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.dataHistory, (data, index) => {
            return (_openBlock(), _createBlock(_component_CardComissionHistory, {
              data: data,
              key: index
            }, null, 8, ["data"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    ($setup.dataHistory.length === 0 && !$setup.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      ref: "dateOp",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_Calendar, {
            modelValue: $setup.dateFilter,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.dateFilter = $event)),
            inline: true,
            showWeek: true,
            selectionMode: "range"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_9, [
            ($setup.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            ($setup.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-secondary text-black p-button-sm px-10 py-1",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearFilterDate()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}